export const FLAGS = {};

export const SWITCHES = {
    ENABLE_DEALER_SELECTOR: 'enable-dealer-selector',
    ENABLE_AK_HI_STATES: 'cap-388-enable-ak-hi-states',
};
